'use client';

import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import { fetchAppetences } from '../utils/fetch-appetences';

export const useAppetencesSidebar = () => {
  const { client } = useApi();

  return useSWR('appetences-quark-sidebar', async () => {
    const {
      data: { session },
    } = await client.auth.getSession();

    if (!session) {
      throw new Error('');
    }

    return fetchAppetences(client, session.user.id);
  });
};
